import { Routes, Route } from "react-router-dom";
import MainNavigation from "./UI/MainNavigation";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Home from "./components/Home";
import Cart from "./components/Cart";
import ProductInfo from "./components/ProductInfo";
import About from "./components/About";
import Footer from "./UI/Footer";
import "./App.css";
import { blurContext } from "./components/BlurContext";
import { useContext } from "react";
import Category from "./components/Category";
import Products from "./components/Products";

export default function MainContent() {
	//import blur context
	const { blur } = useContext(blurContext);
	const main_classes = ["main-content"];

	if (blur) {
		main_classes.push("blur-app");
	}

	return (
		<>
			<div className={main_classes.join(" ")}>
				<MainNavigation />
				<ToastContainer />
				<Routes>
					<Route path="/" element={<Home />} />
					<Route path="/products" element={<Products />} />
					<Route
						path="products/:id"
						element={<ProductInfo />}
					/>
					<Route path="/category/:id" element={<Category />} />
					<Route path="/cart" element={<Cart />} />
					<Route path="/about" element={<About />} />
				</Routes>
			</div>
			<Footer />
		</>
	);
}
